import {
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    styled,
    Toolbar,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { NavLink, useLocation } from "react-router-dom";
import { ASheetCompleteLogoSvg, ASheetLogoSvg, HueSheetLogoSvg } from "../../constants/common-svgs";
import { DRAWER_WIDTH, DRAWER_WIDTH_EXP } from "../../shared/header/header";
import { ASConnection } from "../../shared/menu-icons/as-connection";
import { ASDataCollections } from "../../shared/menu-icons/as-data-collections";
import { ASSettings } from "../../shared/menu-icons/as-settings";
import { ASUsers } from "../../shared/menu-icons/as-users";
import "./side-menu.scss";
import { ASBookAnExpert } from "../../shared/menu-icons/as-book-an-expert";
import { useNavigate } from "react-router-dom";
import { useASContext } from "../../controllers/context-api/as-context";
import { AppEnum } from "../../constants/app-enum";
import { ASDownloadMSExcelPlugin } from "../../shared/menu-icons/as-download-ms-excel-plugin";
import { ASHowToUseAlphaSheet } from "../../shared/menu-icons/as-help";
import { ASHelpPopup } from "../../shared/misc/as-help-popup/as-help-popup";
import { useState } from "react";


const listItems = [
    {
        name: "Connections",
        iconName: (flag) => <ASConnection className="menu-image" flag={flag} />,
        to: "/connections",
        permission: 'all',
    },
    {
        name: "Data Collections",
        iconName: (flag) => <ASDataCollections className="menu-image" flag={flag} />,
        to: "/data-collections",
        permission: 'all',
    },
    {
        name: "Users and Permissions",
        iconName: (flag) => <ASUsers className="menu-image" flag={flag} />,
        to: "/users",
        permission: 'all',
    },
    {
        name: "Settings",
        iconName: (flag) => <ASSettings className="menu-image" flag={flag} />,
        to: "/settings",
        permission: 'all',
    },
    {
        name: "Book an Expert",
        iconName: (flag) => <ASBookAnExpert className="menu-image" flag={flag} />,
        to: "/book-an-expert",
        permission: AppEnum.UserRoleIds.CompanyAdmin,
    },
    {
        name: "Download MS-Excel Plugin",
        iconName: (flag) => <ASDownloadMSExcelPlugin className="new-menu-image" flag={flag} />,
        to: "",
        permission: 'all',
        onClick: () => {
            const link = document.createElement('a');
            link.href = "https://alphasheet.io/plugin/setup/alphasheet.AddIn.msi";
            link.download = "alphasheet.AddIn.msi";
            link.click();
        },
    },
    {
        name: "How to use AlphaSheet",
        iconName: (flag) => <ASHowToUseAlphaSheet className="new-menu-image" flag={flag} />,
        to: "",
        permission: 'all',
    },
    
];


const openedMixin = (theme) => ({
    width: DRAWER_WIDTH_EXP,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(9)} + 0px)`,
    },
});

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
    }),
}));

export function SideMenu({ openDrawer, setOpenDrawer, isHelpPopupOpen, setHelpPopupOpen }) {

    const asContext = useASContext();
    const userRole = asContext?.tenants?.selectedTenant?.UserRoleId?.toLowerCase();

    let filteredSideMenu = listItems.filter(
        item => item.permission === "all" || (item.permission.toLowerCase() === AppEnum.UserRoleIds.CompanyAdmin.toLowerCase() && userRole?.toLowerCase() === AppEnum.UserRoleIds.CompanyAdmin.toLowerCase())
    );

    filteredSideMenu = filteredSideMenu.map((item) => ({
        ...item,
        onClick:
            item.name === "How to use AlphaSheet"
                ? () => setHelpPopupOpen(true)
                : item.onClick,
    }));
    
    return (
        <Drawer open={openDrawer} variant="permanent">
            <Toolbar
                sx={{
                    padding: !openDrawer ? 0 : "0 10px",
                    paddingLeft: !openDrawer ? "16px !important" : "",
                }}
            >
                {openDrawer ? (
                    <div className="a-sheet-complete-svg" onClick={() => setOpenDrawer(!openDrawer)}>
                        <div>{ASheetCompleteLogoSvg}</div>
                    </div>
                    // <img
                    //     className="pointer"
                    //     onClick={() => setOpenDrawer(!openDrawer)}
                    //     src="./assets/logo.svg"
                    //     alt=""
                    // />
                ) : (
                    <div className="a-sheet-svg" onClick={() => setOpenDrawer(!openDrawer)}>
                        {ASheetLogoSvg}
                    </div>
                    // <img
                    //     className="pointer menu-image"
                    //     onClick={() => setOpenDrawer(!openDrawer)}
                    //     src="./assets/_logo.svg"
                    //     alt=""
                    // />
                )}
            </Toolbar>

            <Divider />

            <List>
                <ASListItems openDrawer={openDrawer} listItems={filteredSideMenu} />
            </List>

            <Divider />

            <ASHelpPopup isOpen={isHelpPopupOpen} onClose={() => setHelpPopupOpen(false)} />
        </Drawer>
    );
}
const ASListItems = ({ openDrawer, listItems }) => {
    const navigate = useNavigate();
    const handleOnclick = (to, onClick) => {
        if (onClick) {
            onClick();
        } 
        else {
            navigate(to);
        }
    }
    return (
        <>
            {listItems.map(({ name, iconName, to, onClick }) => (
                <ListItem onClick={() => handleOnclick(to, onClick)} className='nav-link-item' button key={name} sx={{ paddingTop: '4px', paddingBottom: '4px', paddingLeft: '13px' }} >
                    {
                        <ASNavLink
                            name={name}
                            openDrawer={openDrawer}
                            to={to}
                            iconName={iconName}
                        />
                    }
                </ListItem>
            ))}
        </>
    );
};

const ASNavLink = ({ name, openDrawer, to, iconName }) => {
    const _isActive = useLocation().pathname.includes(to);

    return (
        <NavLink
            className={({ isActive }) => (isActive ?
                (openDrawer ? "is-active link" : "is-active-closed link-closed") :
                (openDrawer ? "link" : 'link-closed')
            )}
            to={to}
            onClick={(e) => {
                if (!to) e.preventDefault();
            }}
        >
            <ListItemIcon
                sx={{
                    padding: openDrawer ? 0 : "10px",
                    alignSelf: "center",
                    minWidth: "fit-content",
                    marginRight: openDrawer ? "10px" : "auto",
                }}
            >
                <span className="menu-svg">{iconName(_isActive)}</span>

            </ListItemIcon>

            {openDrawer && (
                <ListItemText
                    primary={name}
                    primaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: "700",
                        fontFamily: 'Poppins'
                    }}
                />
            )}
        </NavLink>
    );
};
